import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { PreflightResult } from '../../../components/preflight/types';

const PLUGIN_ID = 'temporal';
const ERROR_DETAIL_MAX_LENGTH = 200;

export const runWorkerPreflight = async (
  discovery: DiscoveryApi,
  fetchApi: FetchApi,
  objectIds: string[],
): Promise<PreflightResult> => {
  const base = await discovery.getBaseUrl(PLUGIN_ID);
  const response = await fetchApi.fetch(`${base}/preflight/check`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ objectIds }),
  });
  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new Error(
      `Preflight check failed (HTTP ${response.status}): ${text.slice(
        0,
        ERROR_DETAIL_MAX_LENGTH,
      )}`,
    );
  }
  return (await response.json()) as PreflightResult;
};
